export const DROPDOWN_DIRECTIONS = [
  'top',
  'top-left',
  'top-right',
  'left-top',
  'left',
  'left-bottom',
  'right-top',
  'right',
  'right-bottom',
  'bottom-left',
  'bottom',
  'bottom-right',
];
